// react
import React from 'react';
import useForm from 'react-hook-form';
import Datetime from "react-datetime";
import { useTranslation } from 'react-i18next';
import moment from "moment";

// material-ui icons
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";


// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';

// services
import { convertDate, getLocale, formateDate, getStringFormatDate, MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1} from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


export default function PagamentoBoleto({ pgto, CallloadTotalizadorPgtosBo }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {register, errors, handleSubmit, setValue, getValues} = useForm({mode: "onBlur"}); 
    
  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  const [LoadingForm,setLoadingForm]= React.useState(false);
    
  const [showModalBoletos, setshowModalBoletos] = React.useState(false);
  
  const [parcelasBoleto, setParcelasBoleto] = React.useState([]);  

  const [instituicaoFinanceiraOptions, set_instituicaoFinanceiraOptions] = React.useState([
    {text: "Banco do Brasil", value: "Instituição Financeira: Banco do Brasil"},
    {text: "Banco Inter", value: "Instituição Financeira: Banco Inter"},
    {text: "Brasil Card", value: "Instituição Financeira: Brasil Card"},
    {text: "Bradesco", value: "Instituição Financeira: Bradesco"},
    {text: "BV Financeira", value: "Instituição Financeira: BV Financeira"},
    {text: "Caixa", value: "Instituição Financeira: Caixa"},
    {text: "Creditall", value: "Instituição Financeira: Creditall"},
    {text: "C6 Bank", value: "Instituição Financeira: C6 Bank"},
    {text: "Itaú", value: "Instituição Financeira: Itaú"},
    {text: "Losango", value: "Instituição Financeira: Losango"},
    {text: "Nubank", value: "Instituição Financeira: Nubank"},
    {text: "Parcela Mais", value: "Instituição Financeira: Parcela Mais"},
    {text: "Santander", value: "Instituição Financeira: Santander"},
    {text: "Sicredi", value: "Instituição Financeira: Sicredi"},
    {text: "Via Certa", value: "Instituição Financeira: Via Certa"},
  ]);
  
  const [possuiObservacao, setpossuiObservacao] = React.useState(false);
  const [instituicaoFinanceiraSelected, set_instituicaoFinanceiraSelected] = React.useState("");
  const handleInstituicaoFinanceiraChange = (event) => {
      let value = event
      set_instituicaoFinanceiraSelected(value.value);
      
      setpossuiObservacao(false);
      if (value.text === 'Parcela Mais')
      {
        setpossuiObservacao(true);
      }
      
      setValue("observacao", value);
  };

  const OpenModalBoletos = () => {
    var data = getValues();

    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2))
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }

    if (data.primeirovenc == null || data.primeirovenc == "")
      return;

    let valorParcela = "";
    if(parseInt(data.parcelas)===1)
      valorParcela = valor;    
    else
      valorParcela = valor / parseInt(data.parcelas);          

    var parcelas = [];

    let data_vencimento = convertDate(data.primeirovenc);
    let numBoleto = "0000";

    for(var i = 1; i <= data.parcelas; i++){      
      numBoleto = "0000" + i;
      parcelas.push({
        parcela: i,
        vencimento: convertDate(data_vencimento),
        valor: valorParcela,
        numBoleto: numBoleto
      });

      data_vencimento = moment(data_vencimento).add(1, "M");
    }

    setParcelasBoleto(parcelas);
    setshowModalBoletos(true);
  }

  const handleChangeNumeroBoleto = (event, parcela) => {
    let lista = parcelasBoleto;
    let item = lista.filter(f => f.parcela == parcela)[0];
    item.numBoleto = event.target.value;
    lista = lista.map(m => m.parcela == parcela ? item : m);
    setParcelasBoleto(lista);
  }

  const handleChangeVencimento = (date, parcela) => {
    let lista = parcelasBoleto;
    let item = lista.filter(f => f.parcela == parcela)[0];
    let anterior = lista.filter(f => f.parcela == (parcela == 1 ? 1 : parcela - 1))[0];

    if ((parcela == 1 && item.vencimento != convertDate(date)) ||
        (anterior.vencimento < convertDate(date)))
    {
      item.vencimento = convertDate(date);
      lista = lista.map(m => m.parcela == parcela ? item : m);
      setParcelasBoleto(lista);
    }
  }

  const ConfirmarBoletos = () => {
      var data = getValues();

      setLoadingForm(true);
      let valor = transformValueFormatedtoFloat(data.valor);
      let observacao = data?.observacao?.value ?? '';      
      let descParcelas = "";
      if(parseInt(data.parcelas)===1)
        descParcelas = t('label.at_sight');
      else
      {
        let valorPacela = valor / parseInt(data.parcelas);
        descParcelas = data.parcelas + "x "+transformValueFloattoFormated(valorPacela);
      }    
      
      var dataprimeirovencTratado = convertDate(data.primeirovenc);

      // Validação com novo campo Observação
      if (data.observacaoInformada !== '' && data.observacaoInformada !== undefined)
      {
        let tempObservacao = (data?.observacao?.text + ' | '  ?? '') + data.observacaoInformada;
        if (tempObservacao.length > 100)
          observacao = data.observacaoInformada;
        else
          observacao = tempObservacao;
      }

      let pg = {
        id:pgto.pagamentos.length+1,
        tipo: 2, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
        descricaoFormaPgto: 'Boleto',
        valor: valor,
        descTipo: t('sale.billet'),
        parcela: data.parcelas,
        descPacela: descParcelas,
        observacao: observacao,
        dadosComplementarBoleto:{
          primeiroVenc: dataprimeirovencTratado,
          listaBoletos: parcelasBoleto
        }
      }

      let updatepgto ={
        ...pgto,        
        pagamentos:[
          ...pgto.pagamentos,
          pg
        ]
      };
      
      setshowModalBoletos(false);
      clearForm();
      setmessageReturn({show:false})
      setLoadingForm(false);  
      CallloadTotalizadorPgtosBo(updatepgto);   
      return true;
  }

  const clearForm = () =>{
    setValue('valor', '');
    setValue('parcelas', 1);
    setValue('primeirovenc', '');
    setValue('numBoleto', '');
    setValue('vencBoleto_', '');
    setValue('valor_', '');
    setParcelasBoleto([]);
    setValue('observacao', '');
    setValue('observacaoInformada', '');
  }

  var yesterday = Datetime.moment().subtract( 1, 'day' );
  var valid = function( current ){
      return current.isAfter( yesterday );
  };
  
return (
    <div>    
      <form>
        <GridContainer className={classes.containerin}> 
            <GridItem xs={12} sm={3} md={4}>
              <div className={classes.labelIdent}>
                {t('label.financial_institution')} *
              </div>
            </GridItem>    
            <GridItem xs={12} sm={9} md={6}>
                  <div className="removeScroll">
                  <Select
                    styles={ValidSelect(false)} 
                    classNamePrefix="select"            
                    isSearchable={true}
                    name="observacao"
                    placeholder={t('label.select')+"..."}
                    options={instituicaoFinanceiraOptions} 
                    value={instituicaoFinanceiraOptions.filter(({ value }) => value == instituicaoFinanceiraSelected)}      
                    getOptionLabel={({ text }) => text}
                    getOptionValue={({ value }) => value}          
                    onChange={(value) => handleInstituicaoFinanceiraChange(value)}
                    ref={() => register( { name: "observacao" })}
                  />
                  </div>
                  <FormHelperText className={classes.labelRootError}>            
                    {errors.tipoCartao && <span className="obg"> {t('label.required')} </span>}
                  </FormHelperText> 
            </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={4} md={4}>
            <div className={classes.labelIdent}>
              1º {t('label.due_date')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={5} md={4}>
            <Datetime
              locale={getLocale()}
              dateFormat={getStringFormatDate()}
              timeFormat={false}
              name="primeirovenc"  
              isValidDate={ valid }                
              inputProps={{ name:"primeirovenc", ref:register({required: true}), readOnly:'readonly' }} 
              className={errors.primeirovenc?"error":""}            
            />                 
            <FormHelperText>
                {errors.primeirovenc && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>        
        </GridContainer> 

        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={4} md={4}>
            <div className={classes.labelIdent}>
            {t('label.value')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={5} md={4}> 
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue=""  
                  name="valor"               
                  InputProps={{ inputComponent: MaskMoney}}    
                  inputRef={register({required: true})}
                  error={errors.valor?true:false} 
              />
              <FormHelperText>
                  {errors.valor && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>
        </GridContainer>

        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={4} md={4}>
            <div className={classes.labelIdent}>
              Nº {t('label.parcel')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={2}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  name="parcelas"                  
                  defaultValue={1}      
                  type="number"                                                   
                  inputProps={{maxLength: 3}} 
                  onInput={(e) => MaskOnlyNumbersStart1(e) }          
                  inputRef={register({required: true})}
                  error={errors.parcelas?true:false} 
              />
              <FormHelperText>
                  {errors.parcelas && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>   
          <GridItem xs={12} sm={5} md={5}>
            <br/>
            <small>({t('information_message.inform_the_number_of_parcels')})</small>
          </GridItem>       
        </GridContainer>
        
        {
          possuiObservacao &&
          (
            <>
              <GridContainer className={classes.containerin}>
                <GridItem xs={12} sm={4} md={4}>
                  <div className={classes.labelIdent}>
                    {t('label.observation')}
                  </div>
                </GridItem>
                <GridItem xs={12} sm={8} md={8}>  
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      className="inputObs"
                      name="observacaoInformada"
                      inputProps={{maxLength: 64}}
                      multiline
                      rows={4}
                      inputRef={register({required: false})}
                      error={errors.observacaoInformada?true:false} 
                  />
                </GridItem>
              </GridContainer>
            </>
          )
        }
        
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={12} md={12}>
              {messageReturn.show &&
              <div className="alertErrorEx alertmax">
                  <p>
                  {messageReturn.message}   
                  </p>
              </div>
              }
              <br/>
              <center>
              <Button type="button" color="primary" onClick={() => OpenModalBoletos()} >
              {t('button.post_payment')}                     
              </Button>
              {LoadingForm && <CircularProgress />}
              </center>
          </GridItem>
        </GridContainer>
        
        <Dialog
          classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
          open={showModalBoletos}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setshowModalBoletos(false)}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
          >
                  <DialogTitle
                      id="classic-modal-slide-title"
                      disableTypography
                      className={classes.modalHeader}
                      style={{background:'#5c4477'}}
                  >
                      <h4 className={classes.modalTitle} style={{color:'white'}}>Lista de Boletos</h4>
                  </DialogTitle>
                  <DialogContent id="classic-modal-slide-description"
                      className={classes.modalBody}
                  >                 
                  <br/>
                  {parcelasBoleto.length > 0 && 
                    parcelasBoleto.map(item =>                       
                        <GridContainer className={classes.containerin} key={item.parcela}> 
                          <GridItem xs={4} sm={5} md={4}> 
                              <label>Nº {t('label.billet')}</label>
                              <TextField
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{shrink: true}} 
                                  defaultValue= {item.numBoleto}  
                                  name={"numBoleto" + item.parcela}                                
                                  inputRef={register({required: true})}  
                                  onChange={(e) => handleChangeNumeroBoleto(e, item.parcela)}                              
                              />
                          </GridItem> 
                          <GridItem xs={4} sm={4} md={4}>
                            <label>{t('label.due_date')}</label>
                            <Datetime
                              locale={getLocale()}
                              dateFormat={getStringFormatDate()}
                              timeFormat={false}
                              name={"vencBoleto_" + item.parcela}
                              isValidDate={ valid }                
                              inputProps={{ name:"vencBoleto_" + item.parcela, ref:register({required: true}), readOnly:'readonly' }}                             
                              value={item.vencimento}  
                              inputRef={register({required: true})}
                              onChange={(date) => handleChangeVencimento(date, item.parcela)}                                        
                            />                                           
                          </GridItem>   
                          <GridItem xs={4} sm={4} md={4}>
                            <label>{t('label.value')}</label>
                              <TextField
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{shrink: true}}                                 
                                  defaultValue={transformValueFloattoFormated(item.valor)} 
                                  name={"valor_" + item.parcela}
                                  disabled={true}                                
                              />                            
                          </GridItem>
                      </GridContainer>  
                    )                                     
                  }
                  <GridContainer className={classes.containerin}>
                      <GridItem xs={12} sm={12} md={12}>
                        {messageReturn.show &&
                        <div className="alertErrorEx alertmax">
                          <p>
                            {messageReturn.message}   
                          </p>
                        </div>
                        }
                        <br/>
                        <center>
                          <Button type="button" onClick={() => ConfirmarBoletos()} color="primary">
                            {t('button.confirm_billet')}
                          </Button>
                        </center>
                      </GridItem>
                    </GridContainer>   
            </DialogContent>
        </Dialog>
      </form>            
    </div>
);
}